module.exports = function (app) {
	'use strict';

	require('./review')(app);
	require('./addCoverage')(app);

	app.controller('pages.employee.find', ['$scope', '$state', 'services', 'modal', 'employee', 'employeeFinder', 'sessionData', 'storage',
		function($scope, $state, services, modal, employee, employeeFinder, sessionData, storage) {
			$scope.employee = employee;
			$scope.employeeFinder = employeeFinder;

			if (employee.editInProgress.isActive()) { employee.editInProgress.reset(); }

			if (sessionData.entitlements.clientStatus.cancelled && !sessionData.cancelledClientHasAgreed) {
				$state.go('cancelledConditions');
			}


			$scope.$on('$stateChangeStart', function() {
				employeeFinder.purge();
			});

			if (employeeFinder.searchData && Object.keys(employeeFinder.searchData).length) {
				$scope.searchData = angular.copy(employeeFinder.searchData); // this needs to be on $scope to initially populate the form
				employeeFinder.search($scope.searchData);
			}

			$scope.sidebar = {};

			if ($state.previous.name.match('assistEmployees')) {
				$scope.sidebar.breadCrumb = {
					primary: {
						title: 'Assist Employees',
						state: 'assistEmployees'
					},
					secondary: {
						title: 'Find Employee',
						state: 'employee.find'
					}
				};
			}
			else if ($state.previous.name.match('employee.enrollment')) {
				$scope.sidebar.breadCrumb = {
					primary: {
						title: 'Enrollment',
						state: 'employee.enrollment'
					},
					secondary: {
						title: 'Find Employee',
						state: 'employee.find'
					}
				};
			}
			else if ($state.previous.name.match('employee.addCoverage')) {
				$scope.sidebar.breadCrumb = {
					primary: {
						title: 'Add Coverage',
						state: 'addCoverage'
					},
					secondary: {
						title: 'Find Employee',
						state: 'employee.find'
					}
				};
			}
			else {
				$scope.sidebar.breadCrumb = {
					primary: {
						title: 'Find Employee',
						state: 'employee.find'
					}
				};
			}
			// storage.set('pds', 'true');
			if ((storage.get('pds') == 'true') || (storage.get('pds') == true))  {
				// for IBC
				// $scope.searchData = {groupNumber: '10033136'};      10050516
				// for AHNJ
				// $scope.searchData = {groupNumber: '10050516'};
				// $scope.searchData = {groupNumber: '08826200'};   // Change PCP   08873924  Blakeney
				// $scope.searchData = {groupNumber: '08873924'};  // has Kastiel w 5 dependents
				// $scope.searchData = {memberId: '102290578001'};   // Member w a dependent  PA001001TH  Actions button fixes
				// $scope.searchData = {memberId: '122602723001'};   // IBC AHNJ
				$scope.searchData = {groupNumber: '02520100'};  //  Spending Account Elections.  PA = CRE  PA070586G
				// $scope.searchData = {memberId: '865565465'};    // Member w Pending Transactions
				// $scope.searchData = {lastName: 'blakeney'};    // used for Reinstate (has Cancelled members)
			}

			/*$scope.$on('switchToFindPrintMode', function() {
				$scope.printMode = true;
				setBreadcrumbs('Employee Summary');
			});*/

		}]);

	app.run(['$rootScope', '$state', function($rootScope, $state) {
		$rootScope.$on('$stateChangeStart', function(event, toState) {
			$state.next = toState;
		});
	}]);

	var templateWithContent = function (templatePath, state) {
		return (function(state) {
			return ['$location', '$state', '$browser', '$templateFactory', '$stateParams', function($location, $state, $browser, $templateFactory, $stateParams) {
				var url = $state.href(state || $state.next.name).replace($browser.baseHref(),'').replace(/\.html/g,'') + '.employerTemplate.html/' + templatePath;
				return $templateFactory.fromUrl(url, $stateParams);
				// Below is incorrect, it doesn't factor in url params.  Retained here for code clarity.
				// return $templateFactory.fromUrl(url, $state.next.params);
			}];
		})(state);
	};



	return [
		{
			state: 'employee.find',
			url: '/find',
			postPassword: true,
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/landing-page.html'],
					controller: 'pages.employee.find'
				},
				'dashboard@employee.find': {
					templateProvider: templateWithContent('pages/employee/find/find')
				}
			},
			params: { searchData: '' }
		},
		{
			state: 'employee.find.review',
			url: '/review',
			params: { edit: '', print: false,umi:''},
			views: {
				'dashboard@employee.find': {
					templateProvider: templateWithContent('pages/employee/find/review'),
					controller: 'pages.employee.find.review'
				}
			}
			
		},
		{
			state: 'employee.find.addCoverage',
			url: '/add-coverage',
			views: {
				'dashboard@employee.find': {
					templateProvider: templateWithContent('pages/employee/find/addCoverage'),
					controller: 'pages.employee.find.addCoverage'
				}
			}
		}
	];
};
